import {TranslateService} from "@ngx-translate/core";
import {ProdAppInjectorService} from "prod-shared";
import {marker as _translate} from "@biesbjerg/ngx-translate-extract-marker"

export class HubMapTemplate {
  static getIcon(device): string {
    return `<div class="hub-marker ${HubMapTemplate.getClass(device)}"><span>&nbsp;${device.name}&nbsp;</span></div>`;
  }

  static getPopup(device): string {
    const translation = HubMapTemplate.getTranslation;
    return `<h4>${translation(_translate('hub_map_template.details'))}</h4></h4><table class="table table-sm table-bordered table-striped">` +
      `<tr><td>${translation(_translate('hub_map_template.name'))}</${translation(_translate('hub_map_template.details'))}td><td>` + device.name + '</td></tr>' +
      `<tr><td>${translation(_translate('hub_map_template.mac_address'))}</td><td>` + device.hub.macAddress + '</td></tr>' +
      `<tr><td>${translation(_translate('hub_map_template.last_seen'))}</td><td>` + (device.lastSeen !== null ? device.lastSeen : '') + '</td></tr>' +
      `<tr><td>${translation(_translate('hub_map_template.tag'))}</td><td>` + (device.tag !== null ? device.tag : '') + '</td></tr>' +
      `<tr><td>${translation(_translate('hub_map_template.position'))}</td><td><a href="https://www.google.com/maps/place/' + device.hub.latitude + ',' + device.hub.longitude + '" target="_blank">' + device.hub.latitude + ', ' + device.hub.longitude + '</a></td></tr>` +
      '</table>';
  }

  static getTooltip(device): string {
    return HubMapTemplate.getPopup(device);
  }

  private static getDevices(device): string {
    return '';
  }

  static getClass(device): string {
    if (Math.abs(+new Date() - +new Date(device.lastSeen)) / 1000 / 60 / 60 > 1) {
      return 'bg-danger';
    }

    return 'bg-success';
  }

  private static getTranslation(text: string) {
    const translate = ProdAppInjectorService.injector.get(TranslateService);
    return translate.instant(text);
  }
}
